export const COMPANY_GROUP_TITLE_VALIDATION = {
    min: 5,
    max: 500,
};
